export default { sha: 'ba2f0ba8aaff38b0e69621f902611c753a19137d', buildNumber: 'undefined' }
